import {useMutation} from "@tanstack/react-query";
import {ChallengesApi} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";

interface SubmitChallengeResponseParams {
    id: string;
    newsletter?: boolean;
    zipCode?: string;
    firstName?: string;
    lastName?: string;
    milestoneId?: string;
}

export function useSubmitChallengeResponse() {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return useMutation({
        mutationFn: async (params: SubmitChallengeResponseParams) => {
            /*
             * firstName + lastName were added to the backend in Phase 2.4 of
             * the Polaris × COD Full Throttle project. The `@devour/client`
             * generated body type does not yet include them — cast through
             * any until client regen lands, then drop the cast.
             */
            return new ChallengesApi(getConfig(fullToken)).createChallengesIdResponse({
                id: params.id,
                submitChallengeResponseBody: {
                    newsletter: params.newsletter,
                    zipCode: params.zipCode,
                    firstName: params.firstName,
                    lastName: params.lastName,
                    milestoneId: params.milestoneId,
                } as any,
            });
        },
    });
}
